<div
  [class]="
    'relative flex flex-col w-full bg-(--calloutcard-background) gap-(--calloutcard-gap) px-(--calloutcard-padding-x) py-(--calloutcard-padding-y) rounded-(--calloutcard-border-radius) ' +
    (config().shadow ? 'shadow-(--calloutcard-shadow) ' : '') +
    (config().border
      ? 'border-(length:--calloutcard-border-width,var(--border-width-xs)) border-solid border-(--calloutcard-border-color)'
      : '')
  "
>
  @if (config().imageUrl) {
    <div
      class="w-full overflow-hidden shrink-0"
      [ngClass]="{ 'h-[400px]': config().imageUrl }"
    >
      <img
        [src]="config().imageUrl"
        alt=""
        class="w-full h-full object-cover object-center rounded-(--calloutcard-image-border-radius)"
      />
    </div>
  }

  <app-dynamic
    componentName="DynamicText"
    [props]="{ config: titleConfig() }"
  />

  <div class="flex flex-col gap-4 w-full">
    <app-dynamic
      componentName="Button"
      [props]="{ config: primaryButtonConfig(), disabled: disabled() }"
      (action)="onButtonClick($event)"
    />

    @if (secondaryButtonConfig()) {
      <app-dynamic
        componentName="Button"
        [props]="{ config: secondaryButtonConfig(), disabled: disabled() }"
        (action)="onButtonClick($event)"
      />
    }
  </div>

  @if (config().canDismiss) {
    <div class="absolute top-(--calloutcard-padding-y) right-(--calloutcard-padding-x)">
      <app-dynamic
        componentName="IconButton"
        [props]="{ config: { icon: 'x', size: 'sm', border: config().dismissButtonBorder ?? true } }"
        (action)="onDismiss()"
      />
    </div>
  }
</div>
